import { createFileRoute, redirect } from '@tanstack/react-router'
import { ProductCategoryListView } from '@/features/product-categories/product-categories'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/product-categories/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'product_category.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: ProductCategoryListView,
})
